import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../store";
import { goBackInHistory, pushToHistory as pushToHistoryAction, resetHistory } from "../../../reducers/downlineProfile";

const useProfileHistory = (affAbo: string) => {
  const dispatch = useAppDispatch();
  const history = useAppSelector((state) => state.downlineProfile.history);

  useEffect(() => {
    if (affAbo) {
      dispatch(resetHistory(affAbo));
    }
  }, [affAbo, dispatch]);

  const goBack = () => {
    dispatch(goBackInHistory());
  };

  const pushToHistory = (nextAffAbo: string) => {
    dispatch(pushToHistoryAction(nextAffAbo));
  };

  return {
    showBackButton: history.length > 1,
    goBack,
    pushToHistory,
  };
};

export default useProfileHistory;
